/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics. 
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>device-control.model.ts</name>
///
/// <description>
///  
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>30 Aug 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 30Aug16 MM  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import { DeviceControlType } from  "../../services/Crestron.HydrogenAPI.DeviceMetaDataInfoClient";  
export class  DeviceControlModel  { 
    id: string;
    label: string;
    value: any; 
    type: DeviceControlType;
    hardPath?: string;
    softPath?: string;
    required: boolean;
    mask: string;
    placeholder: string;
    alert: boolean;
    locked: boolean;
    options: any[];
    collection: any = null;
    apply: boolean;
    conflicted: boolean;
    inherited: boolean;
    policy: boolean;
    selectable: boolean; 
    visible: boolean;
    suffix: string;
    default?: any;
    validator?: string;
    pending: boolean;
    unsupported: boolean;
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/models/device-data-models/device-control.model.ts